<script setup lang="ts">
import { ref, onMounted, onUpdated } from "vue";

export interface StepsPathProps {
  stepsNumber: number;
  step: number;
}

const props = defineProps<StepsPathProps>();

const dashoffset = ref(400);
const stepValue = ref(0);
const totalDashoffset = 400;
const charge = ref(false);

onMounted(() => {
  stepValue.value = props.step < 2 ? 20 : totalDashoffset / props.stepsNumber;

  setTimeout(() => {
    charge.value = true;
    dashoffset.value = totalDashoffset - stepValue.value * props.step;
  }, 0);
});

onUpdated(() => {
  stepValue.value = props.step < 2 ? 20 : totalDashoffset / props.stepsNumber;
  dashoffset.value = totalDashoffset - stepValue.value * props.step;
});
</script>

<template>
  <svg viewBox="0 0 361 17" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M-0.45459 15.3515C10.8912 10.8622 33.7751 2.05457 84.7452 1.11763C148.458 -0.0535525 226.109 11.0723 263.953 11.0722C298.124 11.072 351.27 7.73886 360.58 6.27496"
      stroke="#50ABED"
      stroke-opacity="0.15"
      stroke-width="1"
      fill="none"
    />
    <path
      v-if="charge"
      class="path"
      d="M-0.45459 15.3515C10.8912 10.8622 33.7751 2.05457 84.7452 1.11763C148.458 -0.0535525 226.109 11.0723 263.953 11.0722C298.124 11.072 351.27 7.73886 360.58 6.27496"
      stroke="#50ABED"
      stroke-width="1"
      fill="none"
    />
  </svg>
</template>

<style scoped lang="scss">
.path {
  stroke-dasharray: 400;
  stroke-dashoffset: v-bind(dashoffset);
  transition: stroke-dashoffset 0.5s linear;
}
</style>
